@if (viewStateLoaded()) {
    @if (viewStateSupportsLayout() && shouldShowLayoutOptions()) {
        <st-list-drop-down
            class="st-discover-view-options__layout"
            labelPosition="after"
            [value]="viewStateLayoutValue()"
            [label]="languageSettings?.PSTWebViewLabel"
            [list]="viewStateLayoutOptions()?.Options"
            (valueOutput)="updateLayout($event)" />
    }

    @if (viewStateSupportsGroupBy()) {
        <st-list-drop-down
            class="st-discover-view-options__group-by"
            mobileIcon="workspaces"
            [disabled]="groupByDisabled()"
            [label]="languageSettings?.PSTWebGroupByLabel"
            [value]="viewStateGroupByValue()"
            [list]="viewStateGroupByOptions()?.Options"
            (valueOutput)="updateGroupBy($event)" />
    }

    @if (viewStateSupportsGroupByOrder()) {
        <button
            mat-icon-button
            [disabled]="(viewStateGroupByOrderDisabled() && isDateField()) || viewStateSortingManual()"
            [matTooltip]="viewStateGroupByOrderTitle()"
            (click)="updateGroupSortOrder()">
            <mat-icon class="material-symbols-outlined">{{ selectCurrentGroupByOrderIcon() }}</mat-icon>
        </button>
    }

    @if (viewStateSupportsSortBy()) {
        <st-list-drop-down
            class="st-discover-view-options__sort-by"
            mobileIcon="sort"
            [disabled]="sortByDisabled()"
            [value]="viewStateSortByValue()"
            [label]="languageSettings?.PSTWebSortByLabel"
            [list]="viewStateSortByOptions()?.Options"
            (valueOutput)="updateSortBy($event)" />
    }

    @if (viewStateSupportsSortByOrder()) {
        <button
            mat-icon-button
            [disabled]="viewStateSortDisabled()"
            [matTooltip]="viewStateSortByOrderTitle()"
            (click)="updateSortOrder()">
            <mat-icon class="material-symbols-outlined">{{ selectCurrentSortByOrderIcon() }}</mat-icon>
        </button>
    }
}
